import { MarkdownText } from 'components/MarkdownText'
import { Icon } from 'components/ui/Icon'
import { memo, useCallback, useMemo, useState } from 'react'
import { sendMessageFeedback } from 'api/feedback'
import { ChatMessage, FeedbackEnum } from 'types/chat-message'
import { ChatRoleEnum } from 'types/chat'
import { getBorderStyle } from 'utils/index'

type TextMessageProps = {
  messageItem: ChatMessage
  text: string
  startsSequence?: boolean
  endsSequence?: boolean
  showBotAvatar?: boolean
  isOperator?: boolean
  img?: JSX.Element
}

const TextMessageComponent = ({
  text,
  startsSequence,
  endsSequence,
  showBotAvatar,
  messageItem,
  img,
}: TextMessageProps) => {
  const botMsgColor = '#f3f4f6'
  const botMsgBackgroundColor = 'var(--primary-100)'
  const [feedback, setFeedback] = useState<FeedbackEnum | undefined>(messageItem.feedback)
  const borderStyle = getBorderStyle(startsSequence, endsSequence)

  const onPressDisLike = useCallback(async () => {
    setFeedback(FeedbackEnum.BAD)
    await sendMessageFeedback({
      messageId: messageItem._id,
      feedback: FeedbackEnum.BAD,
    })
  }, [])

  const showFeedback = useMemo(() => {
    return messageItem.chatSenderRole === ChatRoleEnum.BOT
  }, [messageItem])

  return (
    <div className="tw-flex tw-flex-row tw-items-end tw-space-x-1">
      <div className={`tw-flex tw-w-5 tw-items-end`}>
        {img && <div className={'tw-h-5 tw-w-5'}>{img}</div>}
        <img
          className={`tw-h-5 tw-w-5 tw-rounded-full tw-text-white ${showBotAvatar ? '' : 'tw-hidden'}`}
          src={'icon-bot.svg'}
          alt={'icon bot'}
        />
      </div>
      <div className="tw-flex tw-min-w-[10%] tw-max-w-[80%] tw-flex-col tw-space-x-2">
        <div
          className={`tw-w-fit tw-text-sm ${borderStyle} tw-whitespace-pre-line tw-break-words tw-px-[15px] tw-py-[8px]`}
          style={{ color: botMsgColor, backgroundColor: botMsgBackgroundColor }}
          dir="auto"
        >
          <MarkdownText text={text} />
        </div>
        {/*{isOperator && (*/}
        {/*  <div className={'tw-row-auto justify-between'}>*/}
        {/*    <span className="tw-text-[10px] tw-italic tw-capitalize tw-text-gray-500">*/}
        {/*      {formatISODate(messageItem.createdAt)}*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>
      {showBotAvatar && (
        <div className={'tw-row-auto justify-between'}>
          {/*<span className="tw-text-[10px] tw-italic tw-capitalize tw-text-gray-500">*/}
          {/*  {formatISODate(messageItem.createdAt)}*/}
          {/*</span>*/}
          {showFeedback && (
            <>
              <button onClick={onPressDisLike}>
                <Icon
                  className={'tw-mr-2 tw-ml-2'}
                  icon={['far', 'thumbs-down']}
                  color={feedback === 'bad' ? 'red' : 'white'}
                />
              </button>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export const TextMessage = memo(TextMessageComponent)
